// noinspection SpellCheckingInspection

export const environment = {
  production: true,
  serviceUrl: 'https://service.manager.smuk.co.uk/api',
  environment: 'live',
  version: 'cd1f0e3af0c3b25162564a13d7bbe458f0fd478b-20261103153935',
  authMethods: 'password',
  inputDebounceTime: 500,
  browserWaitTime: 100,
  sentryDSN: 'https://029a58f2e71192bdb1c0469eaed4768c@o4510148473782272.ingest.de.sentry.io/4511105413218384',
  invoicingCutOff: new Date('2026-06-19'),
  echo: {
    key: 'oddpk4z8bhqwmjzt7f3m',
  },
  reverb: {
    cluster: '',
    wsHost: 'service.manager.smuk.co.uk',
    wsPort: 80,
    wssPort: 443,
    forceTLS: true,
  },
}
